import React from 'react';
import loadable from '@loadable/component';
import config from '../../config';
import Preloader from '../../components/Preloader';

const WorkerPage = loadable(
  () => import(
    /* webpackChunkName: "worker-page-chunk" */
    './WorkerPage'
  ),
  {
    fallback: (
      <Preloader isDefault={config.isCustomApp} />
    ),
  }
);

export default WorkerPage;
